import Model from './Model'

export default class Memberships extends Model {
    resource() {
        return 'memberships'
    }

}
